import { FieldPolicy } from '@apollo/client';

export const queueCountsPolicy = (): FieldPolicy => {
  return {
    keyArgs: false,
    merge(existing, incoming = []) {
      return {
        ...existing,
        ...incoming
      };
    }
  };
};
